/**
 * UUID utility functions
 * Provides fallback for environments where crypto.randomUUID is not available
 */

/**
 * Generate a UUID v4 string
 * Uses crypto.randomUUID() if available, otherwise falls back to a custom implementation
 */
export function generateUUID(): string {
  // Check if crypto.randomUUID is available (modern browsers with HTTPS)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    try {
      return crypto.randomUUID();
    } catch (error) {
      console.warn('crypto.randomUUID failed, falling back to custom implementation:', error);
    }
  }

  // Fallback implementation for older browsers or non-HTTPS environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Generate a simple random ID (shorter than UUID)
 * Useful for temporary IDs that don't need to be globally unique
 */
export function generateRandomId(): string {
  return Math.random().toString(36).substr(2, 9);
}
